
import { Component, Vue, Prop, Model } from 'vue-property-decorator';

@Component
export default class CustomCheckbox extends Vue {
  @Model('change', { default: false }) readonly value!: boolean;
  @Prop({ default: '' }) readonly label!: string;
  @Prop({ default: '#40b99d' }) readonly color!: string;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: '' }) readonly classContainer!: string;

  get containerClasses(): string {
    const classes = [this.classContainer];
    if (this.disabled) {
      classes.push('opacity-50 cursor-not-allowed');
    }
    return classes.join(' ');
  }

  get checkboxClasses(): string {
    const classes = ['shadow-sm'];

    if (this.disabled) {
      classes.push('border-gray-300 bg-gray-100');
    } else if (this.value) {
      classes.push('border-current');
    } else {
      classes.push(
        'border-gray-400 group-hover:border-gray-500',
        'bg-white group-hover:bg-gray-50'
      );
    }

    return classes.join(' ');
  }

  get dynamicStyles(): Record<string, string> {
    if (this.value && !this.disabled) {
      return {
        backgroundColor: this.color,
        borderColor: this.color,
      };
    }
    return {};
  }

  handleChange(event: Event): void {
    if (this.disabled) return;

    const target = event.target as HTMLInputElement;
    this.$emit('change', target.checked);
  }
}
